import * as React from 'react';
import * as ReactDOM from 'react-dom';

globalThis.React = React;
globalThis.ReactDOM = ReactDOM;
